<template>
  <div>
    <!-- What's new -->
    <section class="home__news">
      <News :open="true" />
    </section>

    <!-- Stats -->
    <div class="stats-row">
      <div class="stats-player">
        <PlayerStats
          v-if="getPlayer"
          :username="getPlayer.username"
        />
      </div>
      <div class="action-buttons">
        <div class="action-btn-slot">
          <b-tooltip
            label="Go to Lobby"
            :delay="200"
          >
            <router-link to="/lobby">
              <img
                src="@/assets/img/chess/button_live.png"
                class="live-btn-img"
                alt="play"
              />
            </router-link>
          </b-tooltip>
        </div>
        <div
          v-if="getNewHomeworkCount > 0"
          class="action-btn-slot"
        >
          <HomeworkCtaButton :count="getNewHomeworkCount" />
        </div>
      </div>
    </div>

    <!-- Tournament -->
    <section>
      <TournamentRegister
        v-if="getPlayer"
        class="mt-5"
        :subscriptions="getSubscriptions"
        :tournaments="getActiveTournaments"
        :player="getPlayer"
      />
      <TournamentTable
        class="mt-5"
        :tournaments="getActiveTournaments"
        type="Active tournaments"
        :pageSize="5"
      />
    </section>

    <!-- rank table & newsfeed -->
    <section class="columns mt-5">
      <div class="column is-full-mobile is-7-tablet is-7-desktop">
        <LevelTable
          v-if="getPlayer"
          :username="getPlayer.username"
          @onSelectLevel="handleSelectLevel"
        />
      </div>
      <div class="column is-full-mobile is-5-tablet is-5-desktop column__container">
        <PlayersCarousel
          :onlinePlayers="getOnlinePlayers"
          cardType="topMedium"
          :cardSize="88"
          :rows="2"
        />

        <Newsfeed />
      </div>
    </section>

    <!-- Other games -->
    <div class="mt-5">
      <a
        :href="'mega-hero.php' | studentPage"
        class="strat-game-btn"
      >
        <img src="@/assets/img/chess/csa_button_checkmatehero.png" />
      </a>
      <a
        :href="'chessie-challenge.php' | studentPage"
        class="strat-game-btn"
      >
        <img src="@/assets/img/chess/csa_button_chessieschallenge.png" />
      </a>
      <a
        :href="'guess-move-select.php' | commonStrategyPage"
        class="strat-game-btn"
      >
        <img src="@/assets/img/chess/csa_button_playlikegm.png" />
      </a>
      <a
        :href="'legends-select-player.php' | strategyPage"
        class="strat-game-btn"
      >
        <img src="@/assets/img/chess/csa_button_legends.png" />
      </a>
      <a
        :href="'tactics-dojo-select.php' | commonStrategyPage"
        class="strat-game-btn"
      >
        <img src="@/assets/img/chess/csa_button_tactics_dojo.png" />
      </a>
      <a
        :href="'pages/common/mini-games/' | chessquadPage"
        class="strat-game-btn"
      >
        <img src="@/assets/img/chess/csa_button_mini_games.png" />
      </a>
    </div>

    <div>
      <p class="is-size-3">Brain Games</p>
      <a
        :href="'number-champs.php' | strategyPage"
        class="strat-game-btn"
      >
        <img src="@/assets/img/chess/csa_button_numberchamps.png" />
      </a>
      <a
        :href="'gobble-berry.php' | strategyPage"
        class="strat-game-btn"
      >
        <img src="@/assets/img/chess/csa_button_gobbleberry.png" />
      </a>
      <a
        :href="'s-game.php?category=B10&course=en_brn' | strategyPage"
        class="strat-game-btn"
      >
        <img src="@/assets/img/chess/csa_button_snazzyclimb.png" />
      </a>
    </div>
  </div>
</template>

<script>
import News from "@/components/home/News.vue";
import PlayerStats from "@/components/stats/PlayerStats.vue";
import LevelTable from "@/components/home/LevelTable.vue";
import PlayersCarousel from "@/components/lobby/PlayersCarousel.vue";
import Newsfeed from "@/components/home/Newsfeed.vue";
import TournamentTable from "@/components/tournaments/TournamentTable.vue";
import TournamentRegister from "@/components/tournaments/TournamentRegister.vue";
import HomeworkCtaButton from "@/components/home/HomeworkCtaButton.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    TournamentRegister,
    News,
    PlayerStats,
    LevelTable,
    PlayersCarousel,
    Newsfeed,
    TournamentTable,
    HomeworkCtaButton,
  },

  name: "Home",

  computed: {
    ...mapGetters(["getPlayer", "getOnlinePlayers", "getActiveTournaments", "getSubscriptions", "getNewHomeworkCount"]),

    shouldTryToJoinTournament() {
      if (!this.getActiveTournaments || !this.getActiveTournaments.length) {
        return false;
      }
      if (!this.getSubscriptions || !this.getSubscriptions.length) return false;
      //TODO: find a subscription with meta tournamentId in 1 of the active Tournaments
      return true;
    },
  },

  watch: {
    shouldTryToJoinTournament: function () {
      if (!this.shouldTryToJoinTournament) return;
    },
  },

  filters: {
    chessquadPage(page) {
      return `//www.chesssquad.com/${page}`;
    },

    commonStrategyPage(page) {
      return `//www.chesssquad.com/pages/common/strategy-games/${page}`;
    },

    studentPage(page) {
      return `//www.chesssquad.com/pages/chess-student/${page}`;
    },

    strategyPage(page) {
      return `//www.chesssquad.com/pages/chess-student/strategy-games/${page}`;
    },
  },

  methods: {
    handleSelectLevel(level) {
      this.$router.push({
        name: "pVAiLevel",
        query: {
          level: level,
        },
      });
    },
  },
};
</script>

<style scoped>
.column__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.strat-game-btn {
  display: inline-block;
  width: 150px;
}

.stats-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  gap: 1.5rem;
}

/* .stats-player {
  flex: 0 0 auto;
} */

.action-buttons {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
}

.action-btn-slot {
  flex: 0 0 250px;
  width: 250px;
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.live-btn-img {
  max-width: 100%;
  height: auto;
  display: block;
}
</style>
